import {
  pipe, prop, uniqBy,
} from 'ramda';

const distinctArray = (data, distinctBy) => pipe(uniqBy(prop(distinctBy)))(data);

export default distinctArray;
